import { render, staticRenderFns } from "./Ynyanwo.vue?vue&type=template&id=f7f98b6e&scoped=true&"
import script from "./Ynyanwo.vue?vue&type=script&lang=js&"
export * from "./Ynyanwo.vue?vue&type=script&lang=js&"
import style0 from "./Ynyanwo.vue?vue&type=style&index=0&id=f7f98b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f98b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
